<!--
  offline-banner.component.html
  The offline notice bar: an icon, the message, and the two things the user can do
  about it. role="status" so a screen reader announces it when it appears without
  stealing focus from whatever the user was doing.
-->

<div class="offline-banner" *ngIf="isVisible" role="status" aria-live="polite">

  <ion-icon class="offline-banner-icon" name="warning-outline" aria-hidden="true"></ion-icon>

  <div class="offline-banner-text">
    <!-- The state, then the only thing that resolves it. Nothing in this app
         works without the network, so there is no partial-capability caveat to
         make here. -->
    <span class="offline-banner-message">No internet connection. Reconnect to continue.</span>
    <!-- Feedback for a Retry that found nothing — see onRetry(). -->
    <span class="offline-banner-note" *ngIf="retryFoundNothing">Still no connection.</span>
  </div>

  <div class="offline-banner-actions">
    <ion-button
      class="offline-banner-btn"
      fill="clear"
      size="small"
      (click)="onRetry()">
      Retry
    </ion-button>

    <!-- Icon-only: on a phone the message plus two word-buttons wraps, and of the
         two actions Dismiss is the one whose meaning an X carries on its own. -->
    <ion-button
      class="offline-banner-btn offline-banner-dismiss"
      fill="clear"
      size="small"
      aria-label="Dismiss offline message"
      (click)="onDismiss()">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

</div>
